<template>
  <div class="Minister-top information uploadPictures">
    <div class="Minister-top-top Ministerbackground">
      <div class="Minister-top-left Minister-top-color">采购信息</div>
    </div>

    <div class="bianti_box">
    <div class="information_input" style="margin-bottom:20px;" v-for="(item,index) in sourceLink" :key="index">
      <div class="information_Title">
        来源URL
      </div>
      <div class="input_el input_span">
        <div class="newipt">
          <el-input type="textarea" :rows="1"
                    class="width85"
                    :v-model="item"
                    :readonly="true"
          >
          </el-input>
        </div>
      </div>
    </div>
    </div>

  </div>
</template>

<script>
	export default {
    props: {
      sourceLink: {
        type: Array,
        default: [],
      },
    },
		created() {
		}
	}
</script>

<style lang="scss" scoped>
	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;
    margin-bottom: 32px;

		.Ministerbackground {
			background: #d7f0dbff;
		}
		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 80px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}
		}
		.information_content {
			width: calc(100% - 22px);
			overflow: hidden;
			padding: 10px 10px;
			border: 1px solid rgba(168,168,168,0.8);
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			border-top: none !important;
			margin-bottom: 15px;

			.information_Mandarin {
				overflow: hidden;
				// margin-left: 4%;
				display: flex;
				justify-content: space-between;

				ul {
					max-width: 1450px;
					flex: 1;
					display: flex;

					li {
						width: 90px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						// float: left;
						cursor: pointer;
					}
					.liactive {
						background: #2c8dff;
						color: #fff;
					}
				}
			}
			.information_tips {
				line-height: 50px;
				margin-left: 10%;
				color: #f89a9a;
				font-size: 16px;
			}
			.information_input {
				overflow: hidden;
				position: relative;
				.region {
					width: 80px;
					height: 80px;
					background: rgba(0, 0, 0, 0);
					// background: red;
					position: absolute;
					left: 0px;
					top: 50px;
				}
				.information_Title {
					width: 8%;
					overflow: hidden;
					color: #7d7171;
					text-align: right;
					float: left;
					line-height: 33px;
					margin-right: 1%;
					font-weight: bold;
					user-select: none;
					.tips {
						color: red;
					}
				}
				.input_el {
					width: 88%;
					float: left;

					.Preservation {
						float: right;
						padding: 10px 10px;
						background: #73ade9;
						color: #fff;
						margin-top: 5px;
						border-radius: 5px;
					}
				}
			}
		}
	}
	.uploadPictures {
		/deep/ .el-upload-list__item {
			width: 178px;
			height: 178px;
		}
		/deep/ .el-upload--picture-card {
			width: 178px;
			height: 178px;
			line-height: 178px;
			padding: 0 20px;
		}
		/deep/ .selectUpload {
			// .el-upload.el-upload--picture-card,
			.el-upload-list__item-status-label {
				display: none;
			}
		}
		/deep/ .el-dialog__body {
			word-break: break-word;
		}
		.flip-list-move {
			transition: transform 0.5s;
		}
		.no-move {
			transition: transform 0s;
		}
		.ghost {
			opacity: 0.5;
			background: #c8ebfb;
		}
		.showImg {
			width: 148px;
			float: left;
			margin-right: 15px;
		}
	}
  .bianti {
    margin-left: 20px;
    font-size: 16px;
    margin-top: 12px;
    align-items: center;
    .shuxing_box{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .shuxing_box_item{
        margin-left: 20px;
        padding: 6px;
        display: flex;
        align-items: center;
      }
    }

  }

  .bianti_box{
    width: calc(100% - 22px);
    min-height: 120px;
    padding: 10px 10px;
    border: 1px solid rgba(168,168,168,0.8);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top: none !important;
    padding-bottom: 20px;
  }
  .scope_img_img{
    height: 80px;
    width: 80px;
    margin-left: 12px;
    border: 1px dashed darkgrey;
    border-radius: 8px;
    cursor: pointer;
  }
  .prduct_img{
    height: 550px;
    width: 550px;
  }
</style>
